import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CertificateContainer from '../containers/CertificateContainer';
import { MAIN_SECTION_ID } from '../store/view/constants';
import ContentContainer from './ContentContainer';
import GiftCertificateFormContainer from '../containers/GiftCertificateFormContainer';
import withMobile from '../hocs/withMobile';

const MainContent = ({ isMobile }) => (
  <ContentWrapper>
    <ContentContainer isMobile={isMobile} id={MAIN_SECTION_ID}>
      <StyledContainer>
        {!isMobile && <StyledCertificateContainer />}
        <GiftCertificateFormContainer />
      </StyledContainer>
    </ContentContainer>
  </ContentWrapper>
);

const StyledCertificateContainer = styled(CertificateContainer).attrs({
  width: 395,
})`
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);
  align-self: flex-start;
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  background-image: linear-gradient(to bottom, #fcf4e8 0, #fff 15%);
`;

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

MainContent.propTypes = {
  isMobile: PropTypes.bool,
};
MainContent.defaultProps = {
  isMobile: false,
};

export default withMobile(MainContent);
